import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {MetricViewBO} from "./MetricViewBO";
import {ErrorMessage_restate, WarningMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {ICubeSourceMetricId} from "../PA.HyperRectangle.Services/PA.HyperRectangle.Services.IF";
import {CubeSourceMetaDataService} from "../PA.HyperRectangle.Services/CubeSourceMetaDataService";

export class MetricViewBOValidations {

    static async Validate(aBO: MetricViewBO): Promise<void> {
        let v = aBO.WB_MetricView.cif

        ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(v.METRIC_VIEW_ID),"EmptyId", "Metric View ID cannot be empty");

        ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(v.METRIC_VIEW_NAME), "EmptyName", "Metric View Name cannot be empty")

        ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(v.METRIC_VIEW_USAGE),"EmptyUsage", "Metric View Usage cannot be empty")

        let wbCubeSourceId = _.toNumber(v.WB_CUBESOURCE_ID)
        let bInvalidCubeSource =  (v.METRIC_VIEW_USAGE == 'cubeSource') && (!_.isNumber(wbCubeSourceId) || (wbCubeSourceId <= 0))
        ErrorMessage_restate(aBO.ValidateMessageProvider, bInvalidCubeSource,"EmptyCubeSource", "Metric View Cube Source not set")

        if(bInvalidCubeSource)
            return

        let bValidateCubeSourceMetrics = (v.METRIC_VIEW_USAGE == 'cubeSource')
        let dctMetricIds: {[metricId: string]: ICubeSourceMetricId} = {}
        if(bValidateCubeSourceMetrics){
            let mds = new CubeSourceMetaDataService()
            let arr = await mds.getCubeSourceMetricsIds(wbCubeSourceId, {bVisibleOnly: true, bColumnMetricHasAggregator: true})
            dctMetricIds = _.keyBy(arr, (a) => a.MetricId)
        }

        let arrViewMetrics = _.filter(aBO.WB_MetricView.WB_MetricViewMetricRows, aRow => aRow.isActive)
        for(let aMtrcR of arrViewMetrics){

            if(bValidateCubeSourceMetrics){
                if(!(aMtrcR.MetricId in dctMetricIds)){
                    ErrorMessage_restate(aBO.ValidateMessageProvider, true,
                        `InvalidMetric_${aMtrcR.MetricId}`, `Metric ${aMtrcR.MetricName} (${aMtrcR.MetricId}) not in CubeSource`)
                }

            } else {
                if(v.METRIC_VIEW_USAGE != aMtrcR?.WB_MetricDefinitionRow?.cif?.METRIC_USAGE) {
                    ErrorMessage_restate(aBO.ValidateMessageProvider, true,
                        `InvalidMetricUsage_${aMtrcR.MetricId}`, "Usage of " + aMtrcR.MetricId + " Not Aligned with Metric View")
                }
            }

        }

    }

}